<template>
  <div>
    <b-card class="bg-t-dark">
        <b-row>
            <b-col md="2">
                <b-row>
                    <b-col>
                        <EnlightMockupImg/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="mt-2">
                        <h5>
                            {{device_name}}
                        </h5>
                    </b-col>
                </b-row>
            </b-col>
            <b-col md="6">
                <b-row>
                    <b-col>
                        <b-row class="mt-2">
                            <b-col>
                                {{$t("Client")}}: <b>{{client_name}}</b> 
                            </b-col>
                        </b-row>
                        <br>
                        <b-row class="mt-2">
                            <b-col md="6">
                                {{location}}
                            </b-col>
                            <b-col md="6">
                                {{$t("Last maintenance")}}: {{maintenance_date}}
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col md="6">
                                {{$t("Regulatory target")}}: {{regulatory_target}}  
                            </b-col>
                            <b-col md="6">
                                {{$t("Software version")}}: {{software_version}} 
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
            <b-col md="4">
                <b-row>
                    <b-col align="end" class="text-end-od mt-om">
                        {{$t("Equipment")}}: 
                        <br>
                        <b>NS: {{serial_number}}</b>
                    </b-col>
                </b-row>
                <b-row class="equipments-mode-select order-card-buttons">
                    <b-col class="mt-3 text-end">
                        <b-row>
                            <b-col>
                                &nbsp;
                            </b-col>
                        </b-row>
                        <b-row v-if="displayactions">
                            <b-col>
                                <b-dropdown size="sm"  variant="link" toggle-class="text-decoration-none" no-caret id="device-actions">
                                    <template #button-content>
                                        <b-button size="lg" variant="t-blue pt-1">
                                            <svg width="8" height="24" viewBox="0 0 4 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4ZM2 6C0.9 6 0 6.9 0 8C0 9.1 0.9 10 2 10C3.1 10 4 9.1 4 8C4 6.9 3.1 6 2 6ZM2 12C0.9 12 0 12.9 0 14C0 15.1 0.9 16 2 16C3.1 16 4 15.1 4 14C4 12.9 3.1 12 2 12Z" fill="#323232"/>
                                            </svg>
                                        </b-button>
                                    </template>
                                    <b-dropdown-item @click="$emit('onSendOrder')" id="modules-order-page">
                                        <b-icon-journal-richtext />
                                        {{$t('Modules configuration')}}
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="$emit('onassociate')" id="associate-client-page">
                                        <b-icon-check />
                                        {{$t('Associate')}}
                                    </b-dropdown-item>
                                </b-dropdown>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <hr>
        <b-row>
            <b-col md="4">
                <b-row class="mt-2">
                    <b-col>
                        {{$t('Register date')}}: {{null}}
                    </b-col>
                </b-row> 
                <b-row class="mt-2">
                    <b-col>
                        {{$t('Mode')}}: {{regulatory_target}}
                    </b-col>
                </b-row> 
                <b-row class="mt-2">
                    <b-col>
                        {{$t('Pim serial number')}}: {{pim_serial_number}}
                    </b-col>
                </b-row> 
                <b-row class="mt-2">
                    <b-col>
                        {{$t('AM serial number')}}: {{am_serial_number}}
                    </b-col>
                </b-row> 
            </b-col>
            <b-col md="4">
                <b-row class="mt-2">
                    <b-col>
                        {{$t('Ventilation serial number')}}: {{ventilation_board_serial_number}}
                    </b-col>
                </b-row> 
                <b-row class="mt-2">
                    <b-col>
                        {{$t('Pim mac address one')}}: {{pim_mac_address_one}}
                    </b-col>
                </b-row> 
                <b-row class="mt-2">
                    <b-col>
                        {{$t('Pim mac address two')}}: {{pim_mac_address_two}}
                    </b-col>
                </b-row> 
            </b-col>
        </b-row>
    </b-card>
  </div>
</template>

<script>
    import EnlightMockupImg from '@/assets/img/EnlightMockupImg'

    export default {
        components: {
            EnlightMockupImg
        },
        props: [
            'device_name',
            'client_name',
            'maintenance_date',
            'regulatory_target',
            'software_version',
            'serial_number',
            'location',
            'onassociate',
            'onSendOrder',
            'displayactions',
            "pim_serial_number",
            "pim_mac_address_two",
            "pim_mac_address_one",
            "am_serial_number",
            "ventilation_board_serial_number",
        ],
    }
</script>

<style lang="scss">
@media only screen and (max-width: 600px) {
    .btn{
        margin-bottom: 5px;
    }
}
@media only screen and (min-width: 600px) {
    .order-card-buttons{  
        position: absolute;
        bottom: 15px;
        right: 15px;
        width: 33.33333333% !important;
    }
}
  .equipments-mode-select{
    .form-control{
      color: white;
      background: #767E8A;
      border: #767E8A50;
    }
    .form-control:focus {
      color: white;
      background: #767E8A;
      border: #767E8A50;
    }
    .form-select{
      background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e");
      background-repeat: no-repeat;
      background-position: right 0.75rem center;
      background-size: 16px 12px;
    }
    ::-webkit-calendar-picker-indicator {
      filter: invert(1);
    }
  }
</style>